import en from '@locales/en.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const languages = ['en-US'] as const;
export const defaultLanguage: Language = 'en-US';
export type Language = (typeof languages)[number];

i18n.use(initReactI18next).init({
  fallbackLng: defaultLanguage,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: { translation: en },
  },
});

export default i18n;
